import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';

import { getProfile } from './redux/actions/authActions';
import { SET_LOADING } from './redux/types';

// Components
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CustomerMaster from './pages/CustomerMaster';
import ProductMaster from './pages/ProductMaster';
import PaymentModeMaster from './pages/PaymentModeMaster';
import TaxMaster from './pages/TaxMaster';
import DailyRates from './pages/DailyRates';
import OldMetalStock from './pages/OldMetalStock';
import ChitGroups from './pages/ChitGroups';
import CustomerChits from './pages/CustomerChits';
import Billing from './pages/Billing';
import InvoiceList from './pages/InvoiceList';
import EditInvoice from './pages/EditInvoice';
import Reports from './pages/Reports';
import ReportsAnalytics from './pages/ReportsAnalytics';
import GoldsmithManagement from './pages/GoldsmithManagement';
import CustomerOrders from './pages/CustomerOrders';
import GoldsmithPurchases from './pages/GoldsmithPurchases';
import NewCustomerOrder from './pages/NewCustomerOrder';
import EditCustomerOrder from './pages/EditCustomerOrder';
import NewGoldsmithPurchase from './pages/NewGoldsmithPurchase';
import InvoiceNumberMaster from './pages/InvoiceNumberMaster';
import AuditorReport from './pages/AuditorReport';
import CommunicationManagement from './pages/CommunicationManagement';
import InvoicePaymentList from './pages/InvoicePaymentList';
import CustomerOrderPaymentList from './pages/CustomerOrderPaymentList';
import GoldsmithPurchasePaymentList from './pages/GoldsmithPurchasePaymentList';
import RepairOrders from './pages/RepairOrders';
import NewRepairOrder from './pages/NewRepairOrder';
import EditRepairOrder from './pages/EditRepairOrder';
import RepairOrderDetails from './pages/RepairOrderDetails';
import Expenses from './pages/Expenses';
import ProfitAndLoss from './pages/ProfitAndLoss';
import Backup from './pages/Backup';
import UserMaster from './pages/UserMaster';
import RoleMaster from './pages/RoleMaster';
import RolePermission from './pages/RolePermission';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated, loading } = useSelector((state) => state.auth);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && !isAuthenticated) {
      dispatch({ type: SET_LOADING, payload: true });
      dispatch(getProfile());
    }
  }, [dispatch, isAuthenticated]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <div>Loading...</div>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
        />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/customers" element={<CustomerMaster />} />
                  <Route path="/products" element={<ProductMaster />} />
                  <Route path="/payment-modes" element={<PaymentModeMaster />} />
                  <Route path="/tax-master" element={<TaxMaster />} />
                  <Route path="/daily-rates" element={<DailyRates />} />
                  <Route path="/old-metal-stock" element={<OldMetalStock />} />
                  <Route path="/chit-groups" element={<ChitGroups />} />
                  <Route path="/customer-chits" element={<CustomerChits />} />
                  <Route path="/billing" element={<Billing />} />
                  <Route path="/invoices" element={<InvoiceList />} />
                  <Route path="/invoices/edit/:id" element={<EditInvoice />} />
                  <Route path="/invoice-payments" element={<InvoicePaymentList />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/reports/analytics" element={<ReportsAnalytics />} />
                  <Route path="/goldsmiths" element={<GoldsmithManagement />} />
                  <Route path="/customer-orders" element={<CustomerOrders />} />
                  <Route path="/customer-orders/edit/:id" element={<EditCustomerOrder />} />
                  <Route path="/order-payments" element={<CustomerOrderPaymentList />} />
                  <Route path="/repair-orders" element={<RepairOrders />} />
                  <Route path="/repair-orders/new" element={<NewRepairOrder />} />
                  <Route path="/repair-orders/:id/edit" element={<EditRepairOrder />} />
                  <Route path="/repair-orders/:id" element={<RepairOrderDetails />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/reports/pl" element={<ProfitAndLoss />} />
                  <Route path="/goldsmith-purchases" element={<GoldsmithPurchases />} />
                  <Route path="/purchase-payments" element={<GoldsmithPurchasePaymentList />} />
                  <Route path="/new-customer-order" element={<NewCustomerOrder />} />
                  <Route path="/new-goldsmith-purchase" element={<NewGoldsmithPurchase />} />
                  <Route path="/invoice-number-master" element={<InvoiceNumberMaster />} />
                  <Route path="/auditor-report" element={<AuditorReport />} />
                  <Route path="/communication" element={<CommunicationManagement />} />
                  <Route path="/backup" element={<Backup />} />
                  <Route path="/users" element={<UserMaster />} />
                  <Route path="/roles" element={<RoleMaster />} />
                  <Route path="/role-permissions" element={<RolePermission />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Box>
  );
}

export default App;
